import React from 'react';
import {Hyperlink} from '../links';
import styled from 'styled-components';
import {Typography} from '../typography';
import {VerticalSpacer} from '../spacer';
import {AccentColorOptions} from 'epic-ue-theme';
import {CmsButtonProps} from '../buttons/Button';

const Styled = styled.div`
    padding-left: 24px;
    border-left: 3px solid
        ${(p) => p.theme.ifLight(p, 'theme.palette.neutral.stone', 'theme.palette.neutral.steel')};
`;

export interface ExploreCardProps {
    title?: string;
    links?: CmsButtonProps[];
    accentColor?: AccentColorOptions;
}

export const ExploreCard = ({title, links = [], accentColor}: ExploreCardProps): JSX.Element => {
    return (
        <Styled>
            {title ? (
                <>
                    <Typography variant="h2" color="primary">
                        {title}
                    </Typography>
                    <VerticalSpacer variant="heading" />
                </>
            ) : (
                ''
            )}
            <div className="explore-links">
                {links.map((link, i) => (
                    <React.Fragment key={link.label}>
                        <Hyperlink {...link} accentColor={accentColor}>
                            <Typography variant="h3">{link.label}</Typography>
                        </Hyperlink>
                        {i < links.length - 1 ? <VerticalSpacer variant="paragraph" /> : ''}
                    </React.Fragment>
                ))}
            </div>
        </Styled>
    );
};
